import styled from "styled-components";
import { Link } from "gatsby";
import { palette } from "../../styles/global";
import { up, down, between, only } from 'styled-breakpoints';

export const Wrapper = styled.footer`
  padding: 50px 7vw 50px 7vw;
  background-color: ${palette.white};
  color: #001273;
  font-weight: 300;
  display: inline-block;
  width: calc(100% - 14vw);
`

export const Content = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${down('lg')}{
    flex-direction: column;
    gap: 30px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 20px;
  align-items: flex-start;
  ${down('lg')}{
    flex-direction: column;
    width: 100%;
    :nth-child(2){
      align-items: flex-end;
    }
  }
  > span > a{
    color: #00DFB8;
    font-weight: 600;
  }
  > p > a{
    color: #00DFB8;
    font-weight: 600;
  }
`

export const Logo = styled.img`

`